import { $Service } from "./Service";
import { CreateJobReq, Job } from "../types/jobTypes";

export default class JobsService extends $Service {
  public getJobsByUser(): Promise<Job[]> {
    return this.client.get("/jobs");
  }

  public createJob(req: CreateJobReq): Promise<Job> {
    return this.client.post("/jobs", req);
  }
}
